/**
 * When this build was made, on both sides of the wire.
 *
 * Vite injects the same values into the app bundle and the worker bundle, so the date the server
 * reports is by definition the date of the deploy the phone should be running. A date rather than
 * an id on purpose: "the server is newer than me" settles itself after one reload, where "the
 * server differs from me" can loop forever if the two are ever measured differently.
 */

declare const __BUILD_ID__: string;
declare const __BUILT_AT__: string;

export const BUILD_ID: string = typeof __BUILD_ID__ === "string" ? __BUILD_ID__ : "dev";
export const BUILT_AT: string = typeof __BUILT_AT__ === "string" ? __BUILT_AT__ : "";

const parsed = BUILT_AT ? Date.parse(BUILT_AT) : Number.NaN;
export const BUILT_AT_MS: number | null = Number.isFinite(parsed) ? parsed : null;
